import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import { CircularProgress, Box } from '@mui/material';
import { useSnackbar } from '../../contexts/CustomSnackbarContext';
import { authenticateGithub, submitSelectedGithubRepos } from 'redux-store/currentUserActions';
import GithubRepoSelector from './GithubRepoSelector';

const GithubComponent = ({projectId}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { openSnackbar } = useSnackbar();
  const [githubRepos, setGithubRepos] = useState([]);

  useEffect(() => {
    const performGithubAuthentication = async () => {
      const queryParams = new URLSearchParams(location.search);
      const code = queryParams.get('code');

      if (!code) {
        openSnackbar({ message: 'Code is missing', severity: 'error' });
        history.push('/collections');
        return;
      }

      try {
        const response = await dispatch(authenticateGithub({code, projectId})).unwrap();
        if (response.message === 'Github authentication successful') {
          setGithubRepos(response.github_repos);
        } else {
          throw new Error('Github authentication failed');
        }
      } catch (error) {
        history.push('/collections');
      }
    };

    performGithubAuthentication();
  }, [dispatch, history, location, openSnackbar]);

  const handleSelectedRepos = async (selectedRepos) => {
    const response = await dispatch(submitSelectedGithubRepos({selectedRepos, projectId})).unwrap();
    history.push('/collections');
  };

  if(githubRepos.length > 0) {
    return (
      <GithubRepoSelector githubRepos={githubRepos} handleSelectedRepos={handleSelectedRepos} />
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <CircularProgress />
    </Box>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    projectId: state.common.selectedProject?.id,
  };
}

export default connect(mapStateToProps)(GithubComponent);
